package com.kinoshazam.screens.details.compact

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Scaffold
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Rect
import androidx.compose.ui.input.nestedscroll.nestedScroll
import androidx.compose.ui.layout.LayoutCoordinates
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.zIndex
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.layout.ContentScale
import com.kinoshazam.screens.details.BannerContainer
import com.kinoshazam.screens.details.TrailerButton
import com.kinoshazam.screens.details.TrailerLayer
import com.kinoshazam.screens.details.rectInside
import com.kinoshazam.screens.details.syncTrailerActions
import com.kinoshazam.screens.details.syncTrailerCaption
import com.kinoshazam.screens.details.TrailerExpansionState
import com.kinoshazam.screens.details.rememberTrailerCovered
import com.kinoshazam.screens.details.rememberTrailerExpansion
import com.kinoshazam.screens.details.rememberTrailerPull
import com.kinoshazam.screens.details.videoRatingLabel
import com.kinoshazam.screens.details.videoYearLabel
import com.kinoshazam.uiKit.trailer.TrailerControls
import com.kinoshazam.uiKit.trailer.trailerHidesUnderlyingContent
import com.kinoshazam.screens.details.watchCtaLabel
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.expandableDescription.ExpandableDescription
import com.kinoshazam.uiKit.components.cells.cellItem.CellItem
import com.kinoshazam.uiKit.components.cells.cellItem.CellItemState
import com.kinoshazam.uiKit.components.selectableText.SelectableTextState
import com.kinoshazam.uiKit.components.selectableText.SelectableTextView
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.components.localizedGenreName
import com.kinoshazam.uiKit.components.videoItem.CompactVideoItem
import com.kinoshazam.uiKit.components.videoItem.MovieCastItem
import com.kinoshazam.uiKit.components.videoItem.VideoState
import com.kinoshazam.uiKit.episodeItem.EpisodeView
import com.kinoshazam.uiKit.extension.thenIf
import com.kinoshazam.uiKit.theme.BoldExtraLarge
import com.kinoshazam.uiKit.theme.BoldMedium
import com.kinoshazam.uiKit.theme.Medium
import com.kinoshazam.uiKit.theme.MediumMedium
import com.kinoshazam.uiKit.theme.UiKitTheme
import com.kinoshazam.view.ErrorView
import features.videoDetails.DetailsMVIAction
import features.videoDetails.VideoDetailsState
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.back
import kinoshazam.resources.generated.resources.details_cast
import kinoshazam.resources.generated.resources.details_watch_also
import kinoshazam.resources.generated.resources.episode
import kinoshazam.resources.generated.resources.episode_error
import kinoshazam.resources.generated.resources.error
import kinoshazam.resources.generated.resources.favorite
import kinoshazam.resources.generated.resources.favourites
import kinoshazam.resources.generated.resources.fill_favorite
import kinoshazam.resources.generated.resources.left
import kinoshazam.resources.generated.resources.movie
import kinoshazam.resources.generated.resources.play
import kinoshazam.resources.generated.resources.repeat
import kinoshazam.resources.generated.resources.season
import kinoshazam.resources.generated.resources.trailer
import kinoshazam.resources.generated.resources.watch
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
private fun StillHero(
    imageUrl: String?,
    showPoster: Boolean,
    title: String,
    rating: String?,
    countries: String,
    genres: String,
    code: String,
    onMediaPlaced: (LayoutCoordinates) -> Unit,
    onCaptionPlaced: (LayoutCoordinates) -> Unit,
    hidden: Boolean = false,
) {
    Box {
        BannerContainer(
            imageUrl = imageUrl,
            showPoster = showPoster,
            onPlaced = onMediaPlaced,
        )
        HeroCaption(
            title = title,
            rating = rating,
            countries = countries,
            genres = genres,
            code = code,
            overlay = true,
            onCaptionPlaced = onCaptionPlaced,
            hidden = hidden,
        )
    }
}

@Composable
private fun HeroCaption(
    title: String,
    rating: String?,
    countries: String,
    genres: String,
    code: String,
    overlay: Boolean,
    onCaptionPlaced: (LayoutCoordinates) -> Unit,
    hidden: Boolean = false,
) {
    Column(modifier = Modifier.padding(horizontal = 16.dp, vertical = 16.dp)) {
        if (overlay) {
            Spacer(modifier = Modifier.statusBarsPadding().height(80.dp))
        }
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .onGloballyPositioned(onCaptionPlaced)
                .graphicsLayer { alpha = if (hidden) 0f else 1f },
        ) {
            TextLabel(
                state = TextLabelState(
                    text = title,
                    textStyle = BoldExtraLarge,
                    color = UiKitTheme.colors.color_2,
                ),
            )
            rating?.let {
                Spacer(modifier = Modifier.height(12.dp))
                TextLabel(
                    state = TextLabelState(
                        text = it,
                        textStyle = MediumMedium,
                        color = UiKitTheme.colors.color_1,
                    ),
                )
            }
            Spacer(modifier = Modifier.height(12.dp))
            TextLabel(
                state = TextLabelState(
                    text = countries,
                    textStyle = MediumMedium,
                    color = UiKitTheme.colors.color_2,
                ),
            )
            Spacer(modifier = Modifier.height(12.dp))
            TextLabel(
                state = TextLabelState(
                    text = genres,
                    textStyle = MediumMedium,
                    color = UiKitTheme.colors.color_2,
                ),
            )
            if (code.isNotBlank()) {
                Spacer(modifier = Modifier.height(12.dp))
                TextLabel(
                    state = TextLabelState(
                        text = code,
                        textStyle = MediumMedium,
                        color = UiKitTheme.colors.color_2,
                    ),
                )
            }
        }
        if (overlay) {
            Spacer(modifier = Modifier.height(12.dp))
        }
    }
}

@Composable
fun CompactVideoDetailsContent(
    state: VideoDetailsState,
    onAction: (DetailsMVIAction) -> Unit,
    modifier: Modifier = Modifier
) {

    Scaffold(
        modifier = modifier
            .fillMaxSize()
            .background(UiKitTheme.colors.color_3),
        containerColor = UiKitTheme.colors.color_3,
        content = { paddingValues ->
            when {
                state.isLoading -> LoadingScreen()
                state.isError -> ErrorScreen(onAction)
                else -> ContentScreen(paddingValues, state, onAction)
            }
        }
    )
}

@Composable
private fun LoadingScreen() {
    Box(
        modifier = Modifier.fillMaxSize(),
    ) {
        CircularProgressIndicator(
            modifier = Modifier.size(24.dp).align(Alignment.Center),
            color = UiKitTheme.colors.color_1,
            strokeWidth = 2.dp,
        )
//        Text(
//            text = stringResource(Res.string.loading),
//            modifier = Modifier.align(Alignment.Center)
//        )
    }
}

@Composable
private fun ErrorScreen(
    onAction: (DetailsMVIAction) -> Unit,
) {
    Box {
        AppTopBar(showBlur = false, showBack = true, onAction = onAction)
        ErrorView(
            textError = stringResource(Res.string.error),
            textAction = stringResource(Res.string.repeat),
            onAction = { onAction(DetailsMVIAction.Reload) }
        )
    }
}

@Composable
private fun CompactDetailActions(
    state: VideoDetailsState,
    expansion: TrailerExpansionState,
    onAction: (DetailsMVIAction) -> Unit,
    trailerUrl: String?,
    modifier: Modifier = Modifier,
) {
            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(4.dp),
                verticalArrangement = Arrangement.spacedBy(4.dp),
                modifier = modifier.padding(horizontal = 16.dp)
            ) {
                if (state.features.watchVideo) {
                    Button(
                        modifier = Modifier.height(48.dp),
                        colors = ButtonDefaults.buttonColors(
                            containerColor = UiKitTheme.colors.color_1
                        ),
                        onClick = {
                            val imdbId = state.videoInfo?.imdbId
                            // TODO: get url(html code) from settings
                            val url = if (state.videoInfo?.isTvShow == true) {
                                val season = state.selectedSeason?.seasonNumber
                                val episode = state.selectedEpisode?.episodeNumber
                                "https://api.tobaco.ws/embed/imdb/${imdbId}?season=$season&episode=$episode&host=filmot.site&episodesOpen=false"
                            } else {
                                "https://api.tobaco.ws/embed/imdb/${imdbId}?host=filmot.site"
                            }
                            onAction(DetailsMVIAction.OnPlayClicked(url))
                        }
                    ) {
                        Image(
                            painter = painterResource(Res.drawable.play),
                            colorFilter = ColorFilter.tint(UiKitTheme.colors.color_7),
                            contentDescription = null,
                        )

                        Spacer(modifier = Modifier.width(6.dp))

                        val watch = watchCtaLabel(state.watchTarget)
                        TextLabel(
                            state = TextLabelState(
                                text = watch,
                                textStyle = BoldMedium,
                                color = UiKitTheme.colors.color_7,
                            )
                        )
                    }
                }

                if (trailerUrl != null) {
                    TrailerButton(
                        onClick = expansion::toggle,
                        containerColor = UiKitTheme.colors.color_3_80,
                    )
                }

                Button(
                    modifier = Modifier.height(48.dp)
                        .thenIf(Modifier.width(48.dp), state.features.watchVideo),
                    contentPadding = if (state.features.watchVideo) {
                        PaddingValues()
                    } else {
                        ButtonDefaults.ContentPadding
                    },
                    colors = ButtonDefaults.buttonColors(
                        containerColor = if (state.isFavorite) UiKitTheme.colors.color_1 else UiKitTheme.colors.color_3_80
                    ),
                    onClick = {
                        state.videoInfo?.id?.let { videoId ->
                            onAction(DetailsMVIAction.AddToFavorite(videoId))
                        }
                    }
                ) {
                    if (!state.features.watchVideo) {
                        TextLabel(
                            state = TextLabelState(
                                text = stringResource(Res.string.favorite),
                                textStyle = BoldMedium,
                                color = UiKitTheme.colors.color_7,
                            )
                        )

                        Spacer(modifier = Modifier.width(6.dp))
                    }

                    Image(
                        painter = painterResource(if (state.isFavorite) Res.drawable.fill_favorite else Res.drawable.favourites),
                        colorFilter = ColorFilter.tint(UiKitTheme.colors.color_7),
                        contentDescription = null,
                        contentScale = ContentScale.Crop,
                        modifier = Modifier.padding()
                    )
                }
            }
}

@Composable
private fun ContentScreen(
    paddingValues: PaddingValues,
    state: VideoDetailsState,
    onAction: (DetailsMVIAction) -> Unit,
) {
    val scrollState = rememberScrollState()
    val showBlur by remember { derivedStateOf { scrollState.value > 200 } }
    val expansion = rememberTrailerExpansion()
    var trailerFailed by remember { mutableStateOf(false) }
    val trailerUrl = state.videoInfo?.trailerUrl?.takeIf { it.isNotBlank() && !trailerFailed }
    val leaveDetails = {
        TrailerControls.release()
        onAction(DetailsMVIAction.BackClicked)
    }
    val density = LocalDensity.current
    val bannerChrome = TrailerControls.banner
    bannerChrome.title = state.videoInfo?.title.orEmpty()
    bannerChrome.rating = videoRatingLabel(state.videoInfo).orEmpty()
    bannerChrome.countries = state.videoInfo?.countries?.map { gen ->
        gen.name?.replaceFirstChar { it.uppercase() }
    }?.joinToString { it.orEmpty() }.orEmpty()
    bannerChrome.genres = state.videoInfo?.genres?.map { gen ->
        localizedGenreName(gen.name, gen.icon)
    }?.joinToString().orEmpty()
    bannerChrome.year = videoYearLabel(state.videoInfo)
    bannerChrome.centered = false
    bannerChrome.playLabel = watchCtaLabel(state.watchTarget)
    bannerChrome.trailerLabel = stringResource(Res.string.trailer)
    bannerChrome.favoriteLabel = stringResource(Res.string.favorite)
    bannerChrome.showPlay = state.features.watchVideo
    bannerChrome.showTrailer = trailerUrl != null
    bannerChrome.favorite = state.isFavorite
    bannerChrome.onTrailer = expansion::toggle
    bannerChrome.onFavorite = {
        state.videoInfo?.id?.let { videoId ->
            onAction(DetailsMVIAction.AddToFavorite(videoId))
        }
    }
    bannerChrome.onPlay = {
        val imdbId = state.videoInfo?.imdbId
        val url = if (state.videoInfo?.isTvShow == true) {
            val season = state.selectedSeason?.seasonNumber
            val episode = state.selectedEpisode?.episodeNumber
            "https://api.tobaco.ws/embed/imdb/${imdbId}?season=$season&episode=$episode&host=filmot.site&episodesOpen=false"
        } else {
            "https://api.tobaco.ws/embed/imdb/${imdbId}?host=filmot.site"
        }
        onAction(DetailsMVIAction.OnPlayClicked(url))
    }
    val hideUnderTrailer = trailerUrl != null && trailerHidesUnderlyingContent
    val coverTrailer = rememberTrailerCovered(trailerUrl)
    var stage by remember { mutableStateOf<LayoutCoordinates?>(null) }
    var banner by remember { mutableStateOf<Rect?>(null) }
    val hero = remember { arrayOfNulls<LayoutCoordinates>(1) }
    val caption = remember { arrayOfNulls<LayoutCoordinates>(1) }
    val actions = remember { arrayOfNulls<LayoutCoordinates>(1) }
    fun syncCaption(next: LayoutCoordinates? = null) {
        if (next != null) caption[0] = next
        val parent = stage ?: return
        val place = banner ?: return
        val child = caption[0] ?: return
        syncTrailerCaption(child, parent, place, density)
    }
    fun syncActions(next: LayoutCoordinates? = null) {
        if (next != null) actions[0] = next
        val parent = stage ?: return
        val place = banner ?: return
        val child = actions[0] ?: return
        syncTrailerActions(child, parent, place, density)
    }
    fun syncHero(next: LayoutCoordinates? = null) {
        if (next != null) hero[0] = next
        val parent = stage ?: return
        val child = hero[0] ?: return
        child.rectInside(parent)?.let { rect ->
            val shift = scrollState.value.toFloat()
            banner = Rect(
                left = rect.left,
                top = rect.top + shift,
                right = rect.right,
                bottom = rect.bottom + shift,
            )
        }
        syncCaption()
        syncActions()
    }
    val pull = rememberTrailerPull(
        enabled = trailerUrl != null && expansion.progress < 0.02f,
        atTop = { scrollState.value <= 0 },
        onPull = expansion::expand,
    )

    Box(
        modifier = Modifier
            .fillMaxSize()
            .onGloballyPositioned {
                stage = it
                syncHero()
                syncCaption()
                syncActions()
            },
    ) {
        Column(
            modifier = Modifier
                .zIndex(2f)
                .padding(bottom = paddingValues.calculateBottomPadding())
                .nestedScroll(pull)
                .verticalScroll(scrollState)
        ) {
            StillHero(
                imageUrl = state.videoInfo?.backdropUrl ?: state.videoInfo?.imageUrl,
                showPoster = trailerUrl == null || coverTrailer,
                title = state.videoInfo?.title.orEmpty(),
                rating = videoRatingLabel(state.videoInfo),
                countries = state.videoInfo?.countries?.map { gen ->
                    gen.name?.replaceFirstChar { it.uppercase() }
                }?.joinToString { it.orEmpty() }.orEmpty(),
                genres = state.videoInfo?.genres?.map { gen ->
                    localizedGenreName(gen.name, gen.icon)
                }?.joinToString().orEmpty(),
                code = videoYearLabel(state.videoInfo),
                onMediaPlaced = { syncHero(it) },
                onCaptionPlaced = { syncCaption(it) },
                hidden = hideUnderTrailer,
            )

            CompactDetailActions(
                state = state,
                expansion = expansion,
                onAction = onAction,
                trailerUrl = trailerUrl,
                modifier = Modifier
                    .onGloballyPositioned { syncActions(it) }
                    .graphicsLayer { alpha = if (hideUnderTrailer) 0f else 1f },
            )

            Spacer(modifier = Modifier.height(32.dp))

            if (state.videoInfo?.isTvShow == true) SeriesContent(state, onAction)

            if (!state.videoInfo?.description.isNullOrEmpty()) {
                Spacer(modifier = Modifier.height(32.dp))

                ExpandableDescription(
                    text = state.videoInfo?.description.orEmpty(),
                    expanded = state.isFullDescription,
                    onToggle = { onAction(DetailsMVIAction.ClickMore) },
                )
            }

            Spacer(modifier = Modifier.height(32.dp))
            Spacer(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(1.dp)
                    .padding(horizontal = 16.dp)
                    .background(color = UiKitTheme.colors.color_3)
            )

            if (!state.videoCast?.actors.isNullOrEmpty()) {
                CellItem(
                    state = CellItemState(
                        title = TextLabelState(
                            text = stringResource(Res.string.details_cast),
                            color = UiKitTheme.colors.color_2,
                        )
                    )
                )

                LazyRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    itemsIndexed(state.videoCast?.actors.orEmpty()) { index, it ->
                        MovieCastItem(
                            actor = it,
                            onClick = { onAction(DetailsMVIAction.OnActorClicked(it.id)) },
                            modifier = when (index) {
                                0 -> Modifier.padding(start = 16.dp)
                                state.videoCast?.actors?.size?.minus(1) -> Modifier.padding(end = 16.dp)
                                else -> Modifier.padding()
                            }
                        )
                    }
                }
            }

            if (!state.similarMovie.isNullOrEmpty()) {
                CellItem(
                    state = CellItemState(
                        title = TextLabelState(
                            text = stringResource(Res.string.details_watch_also),
                            color = UiKitTheme.colors.color_2,
                        )
                    )
                )

                LazyRow(
                    horizontalArrangement = Arrangement.spacedBy(4.dp),
                    contentPadding = PaddingValues(horizontal = 16.dp)
                ) {
                    itemsIndexed(state.similarMovie.orEmpty()) { index, it ->
                        CompactVideoItem(
                            state = VideoState(
                                id = it.id ?: -1,
                                title = it.title.orEmpty(),
                                image = it.imageUrl,
                                placeHolder = painterResource(Res.drawable.movie),
                                placeHolderColor = UiKitTheme.colors.color_5,
                                onAction = { id ->
                                    onAction(DetailsMVIAction.OnVideoClicked(id))
                                }
                            ),
                            modifier = Modifier.padding(bottom = 16.dp)
                        )
                    }
                }
            }

        }
        TrailerLayer(
            trailerUrl = trailerUrl,
            expansion = expansion,
            banner = banner,
            scrollState = scrollState,
            pullToExpand = true,
            collapsedCorner = 0.dp,
            onBack = leaveDetails,
            onUnavailable = {
                trailerFailed = true
                expansion.collapse()
            },
        )
        AppTopBar(
            showBlur = showBlur,
            showBack = trailerUrl == null || expansion.progress < 0.5f,
            onAction = { action ->
                if (action == DetailsMVIAction.BackClicked) leaveDetails() else onAction(action)
            },
        )
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun AppTopBar(
    showBlur: Boolean,
    showBack: Boolean,
    onAction: (DetailsMVIAction) -> Unit,
) {
    TopAppBar(
        modifier = Modifier
            .zIndex(3f)
            .background(if (showBlur) UiKitTheme.colors.color_3.copy(alpha = 0.9f) else Color.Transparent)
            .statusBarsPadding(),
        title = {
        },
        navigationIcon = {
            if (showBack) {
                Image(
                    painter = painterResource(Res.drawable.back),
                    colorFilter = ColorFilter.tint(UiKitTheme.colors.color_1),
                    contentDescription = null,
                    modifier = Modifier
                        .clickable(onClick = { onAction(DetailsMVIAction.BackClicked) })
                        .padding(16.dp)
                )
            }
        },
        colors = TopAppBarDefaults.topAppBarColors(
            containerColor = Color.Transparent,
        ),
    )
}

@Composable
private fun SeriesContent(
    state: VideoDetailsState,
    onAction: (DetailsMVIAction) -> Unit,
) {
    val tvInfo = state.videoInfo ?: return
    Column {
        LazyRow(
            horizontalArrangement = Arrangement.spacedBy(16.dp),
            contentPadding = PaddingValues(horizontal = 16.dp)
        ) {
            itemsIndexed(tvInfo.seasons ?: emptyList()) { index, it ->
                SelectableTextView(
                    state = SelectableTextState(
                        isSelected = it.seasonNumber == state.selectedSeason?.seasonNumber,
                        title = it.title ?: stringResource(Res.string.season, it.seasonNumber),
                    )
                ) {
                    onAction(DetailsMVIAction.OnSeasonClicked(tvInfo.id ?: -1, it))
                }
            }
        }
        Spacer(modifier = Modifier.height(16.dp))
        if (state.selectedSeason?.episodes.isNullOrEmpty() && !state.isEpisodesLoading) {
            EpisodesError()
        } else {
            LazyRow(
                horizontalArrangement = Arrangement.spacedBy(4.dp),
                contentPadding = PaddingValues(horizontal = 16.dp),
            ) {
                if (state.isEpisodesLoading) {
                    EpisodesSkeleton()
                } else {
                    itemsIndexed(state.selectedSeason?.episodes ?: emptyList()) { index, it ->
                        EpisodeView(
                            isSelected = index + 1 == state.selectedEpisode?.episodeNumber,
                            title = stringResource(Res.string.episode, index + 1),
                        ) {
                            onAction(
                                DetailsMVIAction.OnEpisodeClicked(tvInfo.id ?: -1, it)
                            )
                            // TODO: open episodes info if need
                        }
                    }
                }
            }
        }
    }
}

private fun LazyListScope.EpisodesSkeleton() =
    items(5) {
        EpisodeView(isLoading = true)
    }

@Composable
private fun EpisodesError() {
    Box(
        contentAlignment = Alignment.Center,
        modifier = Modifier
            .fillMaxWidth()
            .size(90.dp)
    ) {
        TextLabel(
            state = TextLabelState(
                text = stringResource(Res.string.episode_error),
                color = UiKitTheme.colors.color_2,
                textStyle = Medium,
            )
        )
    }
}
